/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { SchedulePlanSessionFragmentDoc, ScheduleProjectFragmentDoc, ScheduleWhoFragmentDoc } from '../schedule/Fragments.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PlanningScheduleSessionsQueryVariables = Types.Exact<{
  rangeStart?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  rangeEnd?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  filterByWhoIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  filterByRoleIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  addressId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type PlanningScheduleSessionsQuery = { planSessions: { __typename: 'MissingCapabilities' } | { __typename: 'PlanSessionConnection', edges: Array<{ __typename: 'PlanSessionEdge', node: { __typename: 'PlanSession', id: string, distanceToAddress?: number | null, from: any, till: any, isTentative: boolean, roles: Array<{ __typename: 'ProjectRole', internalName: string, label: string, id: string }>, who: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, project: { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } } }> } };

export type PlanningScheduleResourcesQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
  hasPlanningProject: Types.Scalars['Boolean']['input'];
  planningProjectId: Types.Scalars['ID']['input'];
  userIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  roleIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  distanceToLocation?: Types.InputMaybe<Types.LocationInput>;
  maxDistance?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  availableWithinRangeStart?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  availableWithinRangeEnd?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  availableExcludingProjectIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
}>;


export type PlanningScheduleResourcesQuery = { organisationMemberships: { __typename: 'OrganisationMembershipsConnection', totalCount: number, edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, distanceToProject?: number | null, email: any, firstname: string, familyname: string, fullname: string, phones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }>, roles: Array<{ __typename: 'OrganisationRole', id: string, label: string, internalName: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } }> } };

export type PlanningResourcesFragment = { __typename: 'User', id: string, email: any, firstname: string, familyname: string, fullname: string, phones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }>, roles: Array<{ __typename: 'OrganisationRole', id: string, label: string, internalName: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null };

export type ModifyPlanSessionMutationVariables = Types.Exact<{
  planSession: Types.ModifyPlanSessionInput;
}>;


export type ModifyPlanSessionMutation = { modifyPlanSession: { __typename: 'ModifyPlanSessionResult', planSession: { __typename: 'PlanSession', id: string, from: any, till: any, isTentative: boolean, roles: Array<{ __typename: 'ProjectRole', internalName: string, label: string, id: string }>, who: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, project: { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } } } };

export type DeletePlanSessionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeletePlanSessionMutation = { deletePlanSession: { __typename: 'DeletePlanSessionResult', ok: boolean } };

export const PlanningResourcesFragmentDoc = gql`
    fragment PlanningResources on User {
  id
  email
  phones {
    id
    number
    type
    main
  }
  roles {
    id
    label
    internalName
  }
  homeAddress {
    ...AddressDetails__Address
  }
  ...ScheduleWho
}
    ${AddressDetails__AddressFragmentDoc}
${ScheduleWhoFragmentDoc}`;
export const PlanningScheduleSessionsDocument = gql`
    query PlanningScheduleSessions($rangeStart: DateTime, $rangeEnd: DateTime, $filterByWhoIds: [ID!], $filterByRoleIds: [ID!], $addressId: ID = null) {
  planSessions(
    limit: 0
    filters: {rangeStart: $rangeStart, rangeEnd: $rangeEnd, whoIds: $filterByWhoIds, roleIds: $filterByRoleIds}
  ) {
    ... on PlanSessionConnection {
      edges {
        node {
          id
          ...SchedulePlanSession
          distanceToAddress(addressId: $addressId)
        }
      }
    }
  }
}
    ${SchedulePlanSessionFragmentDoc}`;

/**
 * __usePlanningScheduleSessionsQuery__
 *
 * To run a query within a React component, call `usePlanningScheduleSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningScheduleSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningScheduleSessionsQuery({
 *   variables: {
 *      rangeStart: // value for 'rangeStart'
 *      rangeEnd: // value for 'rangeEnd'
 *      filterByWhoIds: // value for 'filterByWhoIds'
 *      filterByRoleIds: // value for 'filterByRoleIds'
 *      addressId: // value for 'addressId'
 *   },
 * });
 */
export function usePlanningScheduleSessionsQuery(baseOptions?: Apollo.QueryHookOptions<PlanningScheduleSessionsQuery, PlanningScheduleSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningScheduleSessionsQuery, PlanningScheduleSessionsQueryVariables>(PlanningScheduleSessionsDocument, options);
      }
export function usePlanningScheduleSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningScheduleSessionsQuery, PlanningScheduleSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningScheduleSessionsQuery, PlanningScheduleSessionsQueryVariables>(PlanningScheduleSessionsDocument, options);
        }
export function usePlanningScheduleSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanningScheduleSessionsQuery, PlanningScheduleSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanningScheduleSessionsQuery, PlanningScheduleSessionsQueryVariables>(PlanningScheduleSessionsDocument, options);
        }
export type PlanningScheduleSessionsQueryHookResult = ReturnType<typeof usePlanningScheduleSessionsQuery>;
export type PlanningScheduleSessionsLazyQueryHookResult = ReturnType<typeof usePlanningScheduleSessionsLazyQuery>;
export type PlanningScheduleSessionsSuspenseQueryHookResult = ReturnType<typeof usePlanningScheduleSessionsSuspenseQuery>;
export type PlanningScheduleSessionsQueryResult = Apollo.QueryResult<PlanningScheduleSessionsQuery, PlanningScheduleSessionsQueryVariables>;
export const PlanningScheduleResourcesDocument = gql`
    query PlanningScheduleResources($offset: Int, $limit: Int!, $hasPlanningProject: Boolean!, $planningProjectId: ID!, $userIds: [ID!], $roleIds: [ID!], $search: String, $distanceToLocation: LocationInput, $maxDistance: Float, $availableWithinRangeStart: DateTime, $availableWithinRangeEnd: DateTime, $availableExcludingProjectIds: [ID!]) {
  organisationMemberships(
    offset: $offset
    limit: $limit
    sorting: [{column: familyname, direction: asc}]
    filters: {statuses: [ACTIVATED], ids: $userIds, roleIds: $roleIds, maxDistanceFromHomeAddressToLocationInKm: $maxDistance, distanceFromHomeAddressToLocation: $distanceToLocation, availableWithinRangeStart: $availableWithinRangeStart, availableWithinRangeEnd: $availableWithinRangeEnd, availableExcludingProjectIds: $availableExcludingProjectIds}
    search: $search
  ) {
    edges {
      node {
        id
        distanceToProject(projectId: $planningProjectId) @include(if: $hasPlanningProject)
        ...PlanningResources
      }
    }
    totalCount
  }
}
    ${PlanningResourcesFragmentDoc}`;

/**
 * __usePlanningScheduleResourcesQuery__
 *
 * To run a query within a React component, call `usePlanningScheduleResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningScheduleResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningScheduleResourcesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      hasPlanningProject: // value for 'hasPlanningProject'
 *      planningProjectId: // value for 'planningProjectId'
 *      userIds: // value for 'userIds'
 *      roleIds: // value for 'roleIds'
 *      search: // value for 'search'
 *      distanceToLocation: // value for 'distanceToLocation'
 *      maxDistance: // value for 'maxDistance'
 *      availableWithinRangeStart: // value for 'availableWithinRangeStart'
 *      availableWithinRangeEnd: // value for 'availableWithinRangeEnd'
 *      availableExcludingProjectIds: // value for 'availableExcludingProjectIds'
 *   },
 * });
 */
export function usePlanningScheduleResourcesQuery(baseOptions: Apollo.QueryHookOptions<PlanningScheduleResourcesQuery, PlanningScheduleResourcesQueryVariables> & ({ variables: PlanningScheduleResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningScheduleResourcesQuery, PlanningScheduleResourcesQueryVariables>(PlanningScheduleResourcesDocument, options);
      }
export function usePlanningScheduleResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningScheduleResourcesQuery, PlanningScheduleResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningScheduleResourcesQuery, PlanningScheduleResourcesQueryVariables>(PlanningScheduleResourcesDocument, options);
        }
export function usePlanningScheduleResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanningScheduleResourcesQuery, PlanningScheduleResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanningScheduleResourcesQuery, PlanningScheduleResourcesQueryVariables>(PlanningScheduleResourcesDocument, options);
        }
export type PlanningScheduleResourcesQueryHookResult = ReturnType<typeof usePlanningScheduleResourcesQuery>;
export type PlanningScheduleResourcesLazyQueryHookResult = ReturnType<typeof usePlanningScheduleResourcesLazyQuery>;
export type PlanningScheduleResourcesSuspenseQueryHookResult = ReturnType<typeof usePlanningScheduleResourcesSuspenseQuery>;
export type PlanningScheduleResourcesQueryResult = Apollo.QueryResult<PlanningScheduleResourcesQuery, PlanningScheduleResourcesQueryVariables>;
export const ModifyPlanSessionDocument = gql`
    mutation ModifyPlanSession($planSession: ModifyPlanSessionInput!) {
  modifyPlanSession(input: $planSession) {
    planSession {
      id
      ...SchedulePlanSession
    }
  }
}
    ${SchedulePlanSessionFragmentDoc}`;
export type ModifyPlanSessionMutationFn = Apollo.MutationFunction<ModifyPlanSessionMutation, ModifyPlanSessionMutationVariables>;

/**
 * __useModifyPlanSessionMutation__
 *
 * To run a mutation, you first call `useModifyPlanSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyPlanSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyPlanSessionMutation, { data, loading, error }] = useModifyPlanSessionMutation({
 *   variables: {
 *      planSession: // value for 'planSession'
 *   },
 * });
 */
export function useModifyPlanSessionMutation(baseOptions?: Apollo.MutationHookOptions<ModifyPlanSessionMutation, ModifyPlanSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyPlanSessionMutation, ModifyPlanSessionMutationVariables>(ModifyPlanSessionDocument, options);
      }
export type ModifyPlanSessionMutationHookResult = ReturnType<typeof useModifyPlanSessionMutation>;
export type ModifyPlanSessionMutationResult = Apollo.MutationResult<ModifyPlanSessionMutation>;
export type ModifyPlanSessionMutationOptions = Apollo.BaseMutationOptions<ModifyPlanSessionMutation, ModifyPlanSessionMutationVariables>;
export const DeletePlanSessionDocument = gql`
    mutation DeletePlanSession($id: ID!) {
  deletePlanSession(id: $id) {
    ok
  }
}
    `;
export type DeletePlanSessionMutationFn = Apollo.MutationFunction<DeletePlanSessionMutation, DeletePlanSessionMutationVariables>;

/**
 * __useDeletePlanSessionMutation__
 *
 * To run a mutation, you first call `useDeletePlanSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanSessionMutation, { data, loading, error }] = useDeletePlanSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlanSessionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanSessionMutation, DeletePlanSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanSessionMutation, DeletePlanSessionMutationVariables>(DeletePlanSessionDocument, options);
      }
export type DeletePlanSessionMutationHookResult = ReturnType<typeof useDeletePlanSessionMutation>;
export type DeletePlanSessionMutationResult = Apollo.MutationResult<DeletePlanSessionMutation>;
export type DeletePlanSessionMutationOptions = Apollo.BaseMutationOptions<DeletePlanSessionMutation, DeletePlanSessionMutationVariables>;